<div class="container">
	<div class="title">{{ "SIGN_IN" | translate }}</div>

	<form name="choosePublicationForm">
		<p class="description">{{ "SELECT_PUBLICATION" | translate }}</p>

		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{"PUBLICATION_NAME" | translate}}</mat-label>
			<span matPrefix><i class="far fa-user"></i></span>
			<mat-select [(ngModel)]="selectedPublication" name="publication_name">
				<mat-option *ngFor="let pub of availablePublications" [value]="pub.value">
					{{ pub.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<div class="remember-container">
			<label>
				<bb-check theme="rb" [(ngModel)]="rememberPublicationSelection" name="rememberPublicationSelection"
					[ngModelOptions]="{standalone: true}">
				</bb-check>
				{{ 'REMEMBER_SELECTION' | translate }}
			</label>
		</div>

		<div class="button-container">
			<bb-button theme="rb" backgroundColor="blue" (click)="loginWithPublication()"
				[disabled]="!selectedPublication">
				{{ "SIGN_IN" | translate }}
			</bb-button>
		</div>
	</form>

	<bb-line-text>
		<a href="https://support.bluebillywig.com/online-video-platform-6-preview/authentication-and-login"
			target="_BLANK">{{ 'NEED_HELP' | translate }}</a>
	</bb-line-text>
</div>
